import styles from './Flow.module.scss'
import React from 'react'

type Props = {
  contents: {
    icon: string
    title: string
    text: string
  }[]
}

export const Flow: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.flow_container}>
      <div className={styles.main_container}>
        <p className={styles.title}>導入までの流れ</p>
        <div className={styles.flow_list_container}>
          {contents.map((content, index) => (
            <React.Fragment key={content.title}>
              <div className={styles.flow_item}>
                <div className={styles.flow_icon_container}>
                  <img src={content.icon} alt={content.title} className={styles.flow_icon} />
                </div>
                <div className={styles.flow_text_container}>
                  <div className={styles.flow_text_top_container}>
                    <p className={styles.flow_number}>{`STEP${index + 1}`}</p>
                    <p className={styles.flow_title}>{content.title}</p>
                  </div>
                  <p className={styles.flow_text}>{content.text}</p>
                </div>
              </div>
              {index < contents.length - 1 && <div className={styles.border} />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}
